import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { RecoverState } from "slotworks/state-machine/standard/states/recover-state";

// Jump the reels to the root spin records grid
export class RecoverMatrixState extends RecoverState {
    public onEnter() {
        const gameplay = gameState.getCurrentGame();
        const record = gameplay.getRootRecord();

        if (record instanceof SpinRecord && record.grid) {
            Components.get(AbstractMatrixComponent).jumpToGrid(record.grid);
        }

        super.onEnter();
    }
}
